import { Uuid } from "@/domains/global/identifiers";
import { api } from "@/modules/api";
import { useQuery } from "@tanstack/react-query";
import { FC, useMemo } from "react";
import { useNavigate, useParams } from "react-router";
import { Button } from "@radix-ui/themes";
import { atlasRoutes } from "@/app/router/routes";
import { DateTime } from "luxon";

export const LegacyFirestoreUsersViewPage: FC = () => {
  const navigate = useNavigate();

  const { legacyFirestoreUserId } = useParams<{ legacyFirestoreUserId: Uuid }>();

  if (!legacyFirestoreUserId) {
    return <div>Invalid ID</div>;
  }

  const result = useQuery({
    queryKey: ["legacy-firestore-user-by-id", legacyFirestoreUserId],
    queryFn: () =>
      api.get("/internal/v1/legacy-firestore-users/{legacy_firestore_user_id}", {
        params: {
          path: {
            legacy_firestore_user_id: legacyFirestoreUserId,
          },
        },
      }),
    staleTime: DateTime.fromObject({ minute: 1 }).toMillis(),
  });

  const usageStats = useQuery({
    queryKey: ["legacy-firestore-user-usage-stats", legacyFirestoreUserId],
    queryFn: () =>
      api.get("/internal/v1/legacy-firestore-users/{legacy_firestore_user_id}/usage-stats", {
        params: { path: { legacy_firestore_user_id: legacyFirestoreUserId } },
      }),
  });

  const searchPath = useMemo(() => {
    const emailAddress = result.data?.data?.normalized_profile_email_address;

    if (!emailAddress) {
      return null;
    }

    return `${atlasRoutes.spaceAccounts({}).path}?query=${emailAddress}`;
  }, [result.data?.data]);

  return (
    <div>
      <br />
      <Button
        variant="outline"
        onClick={() => {
          if (!result.data?.data?.firestore_user_id) {
            alert("No legacy firestore user ID found.");
            return;
          }

          navigate(
            atlasRoutes.legacyFirestoreUsersView({
              params: { legacyFirestoreUserId: result.data?.data?.firestore_user_id },
            }).path
          );
        }}
      >
        View Legacy Firestore User
      </Button>
      <br />

      <br />
      <h1>View Legacy Firestore User</h1>
      <pre>{JSON.stringify(result.data, null, 2)}</pre>
      <br />
      <h2>Usage Stats</h2>
      <pre>{JSON.stringify(usageStats.data, null, 2)}</pre>
      <Button variant="outline" onClick={() => searchPath && navigate(searchPath)}>
        Search for V2 Accounts Matching Email Address
      </Button>
    </div>
  );
};
